import { useCallback, useEffect, useState } from "react";
import { useMounted } from "./useMounted.js";
export function useAsyncEffect(effect, deps) {
    useEffect(() => {
        Promise.resolve(effect())
            .catch(error => console.log("Uncaught error from useAsyncEffect", error));
    }, deps);
}
export function useAsync(asyncFunc, deps) {
    const asyncState = useAsyncCallback(asyncFunc, deps);
    useAsyncEffect(asyncState.execute, [asyncState.execute]);
    return asyncState;
}
export function useAsyncCallback(callback, deps) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const [result, setResult] = useState(undefined);
    const mounted = useMounted();
    const execute = useCallback(async (...args) => {
        setLoading(true);
        setError(undefined);
        try {
            const result = await callback(...args);
            if (mounted()) {
                setResult(result);
                setLoading(false);
            }
        }
        catch (error) {
            if (mounted()) {
                setError(error);
                setLoading(false);
            }
        }
    }, deps);
    const clear = useCallback(() => {
        setLoading(false);
        setError(undefined);
        setResult(undefined);
    }, []);
    return { loading, error, result, execute, clear };
}
//# sourceMappingURL=async.js.map